import {Button} from '@mantine/core';
import {AiOutlineSwap} from 'react-icons/ai';

import {useMigrateCodePipelineMutation} from '../hooks/usePipelinesQuery';
import {usePipelines} from '../hooks/usePipelines';
import {usePipelinesSelection} from '../hooks/usePipelinesSelection.ts';


export const MigrateRecordButton = () => {

    const migrateCodePipelineMutation = useMigrateCodePipelineMutation();
    const {items: pipelines} = usePipelines();

    const {
        selection,
        handleClearSelection,
    } = usePipelinesSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const selectedPipelines = pipelines.filter(p => recordIds.includes(p.id));
    const disabled = recordIds.length === 0 || !selectedPipelines.every(p => p.pipelineStatus === 'IMPORTED');

    const handleMigrate = async () => {
        for (const id of recordIds) {
            await migrateCodePipelineMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (
        <Button
            disabled={disabled}
            onClick={handleMigrate}
            loading={migrateCodePipelineMutation.isPending}
            leftSection={<AiOutlineSwap/>}
        >
            Migrate
        </Button>
    );

};
